import { render, staticRenderFns } from "./Apostas.vue?vue&type=template&id=600039f6"
import script from "./Apostas.vue?vue&type=script&lang=js"
export * from "./Apostas.vue?vue&type=script&lang=js"
import style0 from "./Apostas.vue?vue&type=style&index=0&id=600039f6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports